<template>
    
</template>

<script>
    import {mapState,mapActions} from 'vuex';

    export default {
        name: "ProductCheckoutComponent",
        data () {
            return {
                rendersWithVue: true,
                componentType: "product-checkout"
            }
        },
        computed: {
            myProductId () {

            },
            myProductType () {

                if (this.isPageContext('payment') && this.pageContext.params) {
                    return this.pageContext.params.slug;
                }

                return "";
            },
            myProductData () {

            },
            productCheckoutTemplate () {
                return "ProductCheckoutTemplate1";
            },
            templateProps () {
                return {

                }
            },
            translations () {
                return {
                    "product_name": "Product name",
                    "product_type": "Product type",
                    "courses_included" : "Courses included",
                    "price" : "Price",
                    "subscription": this.$t('common.single_subscription'),
                    "bundle": this.$t('common.bundle'),
                    "course": this.$t('common.course'),
                    "coupon_title": this.$t('common.coupon_title')
                }
            }
        },
        methods: {},
    }
</script>

